import { currentUserIDState } from '@atom/setting/user';
import { cookieStore } from '@store/cookie/cookieStore';
import { fuego } from '@store/firebase';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

function useValidLogin(defaultBoolean?: boolean): boolean {
  const [isValidLogin, setValidLogin] = useState(defaultBoolean || false);
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);
  const cacheUserId = cookieStore.getUserToken();
  const currentUserUid = useRecoilValue(currentUserIDState);

  // Firebase Auth State 실시간 감지
  useEffect(() => {
    const unsubscribe = fuego.auth().onAuthStateChanged((user) => {
      setCurrentUserId(user?.uid || null);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    const hasCookieToken = Boolean(cacheUserId);
    const hasFirebaseUser = Boolean(currentUserId);
    const hasRecoilUser = Boolean(currentUserUid);

    // 모든 조건이 만족되어야 유효한 로그인으로 판단
    const isValid = hasCookieToken && hasFirebaseUser && hasRecoilUser;

    // 디버깅용 로그 (개발 환경에서만)
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('🔐 로그인 상태 체크:', {
    //     hasCookieToken,
    //     hasFirebaseUser,
    //     hasRecoilUser,
    //     isValid,
    //     cacheUserId: cacheUserId ? '있음' : '없음',
    //     currentUserId: currentUserId ? '있음' : '없음',
    //     currentUserUid: currentUserUid ? '있음' : '없음',
    //   });
    // }

    setValidLogin(isValid);
  }, [cacheUserId, currentUserId, currentUserUid]);

  return isValidLogin;
}

export default useValidLogin;
